import { createContext } from 'react';

import { defaultContextValue } from '../../utils/scrollObserver';

import type { ScrollObserverRootContextState } from '../../provider/ScrollObserverProvider';

const ScrollObserverRootContext =
  createContext<ScrollObserverRootContextState>(defaultContextValue);

export default ScrollObserverRootContext;
